<template>
  <filter-bar>
    <div class="md-layout-item md-layout md-medium-size-33 md-small-size-33 md-xsmall-size-100">
      <div class="md-layout-item md-layout md-size-100">
        <md-field>
          <label for="dateFrom">
            <md-icon>calendar_today</md-icon>
            <span v-show="!dateFrom">Desde</span>
          </label>
          <datetime
            input-style="border: none; outline:none; width: 100%"
            v-model="dateFrom"
            type="date"
            title="Desde"
            value-zone="America/Mexico_City"
            :phrases="{ok: '', cancel: ''}"
            auto
          ></datetime>
          <md-button class="md-simple md-just-icon" @click="dateFrom = null">
            <md-icon>close</md-icon>
          </md-button>
        </md-field>
      </div>
    </div>

    <div class="md-layout-item md-layout md-medium-size-33 md-small-size-33 md-xsmall-size-100">
      <div class="md-layout-item md-layout md-size-100">
        <md-field>
          <label for="dateOccurred">
            <md-icon>calendar_today</md-icon>Hasta
          </label>
          <datetime
            input-style="border: none; outline:none; width: 100%"
            v-model="dateTo"
            type="date"
            title="Hasta"
            value-zone="America/Mexico_City"
            :phrases="{ok: '', cancel: ''}"
            auto
          ></datetime>

          <md-button class="md-simple md-just-icon" @click="dateTo = null">
            <md-icon>close</md-icon>
          </md-button>
        </md-field>
      </div>
    </div>

    <div class="md-layout-item md-layout md-medium-size-33 md-small-size-33 md-xsmall-size-100">
      <div class="md-layout-item md-layout md-size-100">
        <md-field>
          <label>Autopista</label>
          <md-select v-model="selectedHighway">
            <md-option :value="0">Todas</md-option>
            <md-option
              v-for="highway in highways"
              :key="highway.id"
              :value="highway.id"
            >{{highway.name}}</md-option>
          </md-select>
        </md-field>
      </div>
    </div>
  </filter-bar>
</template>

<script>
import { Slider, Collapse } from "@/components";
import catalogService from "@/services/catalog";
import FilterBar from "@/components/FilterBar";

export default {
  components: {
    Slider,
    Collapse,
    FilterBar,
  },
  data() {
    return {
      dateFrom: null,
      dateTo: null,
      selectedHighway: null,
      highways: [],
    };
  },
  created() {
    catalogService
      .fetch("highway", { noStore: true })
      .then((highways) => (this.highways = highways));
  },
  props: {
    source: {
      type: Array,
    },
  },
  watch: {
    filteredData() {
      this.$emit("filtered", this.filteredData);
    },
    selectedHighway(value) {
      this.$emit("highwaySelected", value);
    },
    dateFrom(value) {
      this.$emit("dateFromSelected", value);
    },
    dateTo(value) {
      this.$emit("dateToSelected", value);
    },
  },
  computed: {
    filteredData: function () {
      const dFrom = this.dateFrom;
      const dTo = this.dateTo;
      const hi = this.selectedHighway;
      return this.source
        .filter((quo) => (dFrom ? quo.addDate >= dFrom : true))
        .filter((quo) => (dTo ? quo.addDate <= dTo : true))
        .filter((quo) => (hi ? quo.highway.id == hi : true));
    },
  },
};
</script>

<style lang="scss" scoped>
.md-card-content:last-of-type {
  padding-bottom: 0px;
}

.md-card .md-card-content {
  padding: 0px 15px;
  line-height: 1.75em;
  position: relative;
}

.md-field.md-focused label,
.md-field.md-has-value label,
.md-field.md-focused.md-has-value label {
  color: #6d6d6dab !important;
  font-weight: bold;
  font-size: 1.4rem;
}

.md-field.md-focused label,
.md-field.md-field.md-has-value label {
  top: -1rem;
}
</style>



// WEBPACK FOOTER //
// src/pages/Purchases/Quotations/Filters.vue